export default "__VITE_ASSET__BLBRayl7__"